import { Drawer } from 'antd';
import styled, { css } from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  position: relative;
  height: 100vh;
  overflow: auto;
  padding: 10px 0;

  .ant-drawer-header {
    display: none;
  }

  .ant-drawer-body {
    padding: 0 30px 10px;
  }
`;

export const HeaderWrapper = styled.div`
  padding: 20px 0 25px;
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;

  nav li {
    display: flex;
    align-items: center;
  }
`;

export const LeftSideHeader = styled.div`
  display: flex;
`;

export const RightSideHeader = styled.div`
  display: flex;
`;

export const Divider = styled.div`
  height: 20px;
  width: 1px;
  background-color: #1e1e1e;
  opacity: 0.3;
  margin: 5px 10px 0;
`;

const clickableStyle = css`
  cursor: pointer;
  color: #0046ff;

  &:hover {
    color: rgb(0 0 0 / 88%);
    background-color: rgb(0 0 0 / 6%);
  }
`;

export const Title = styled.div<{ clickable?: boolean }>`
  color: #4a4a4a;
  font-size: 20px;
  ${(props) => (props.clickable ? clickableStyle : '')}
`;
